import React from 'react';
import { Container } from 'reactstrap';
import { Footer } from './Footer';
import { NavMenu } from './NavMenu';
import './Layout.css';

export const Layout = ({ children }) => {
    return (
        <div
            className="d-flex flex-column min-vh-100"
            style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
        >
            <NavMenu className="flex-grow-1" />
            <Container className="flex-grow-1">
                {children}
            </Container>
            <Footer />
        </div>
    );
};

Layout.displayName = 'Layout';